<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Disbursment Report</strong>  
            <div class="card-header-actions">
              <a  @click="refresh" title="Refresh">  
                <span class="icon is-medium" >
                 <span class="fa fa-refresh" id="refreshId" > </span>
                </span>
              </a>
            </div>      
          </div>   
          <div class="box">
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                  <b-form-group label="Date:"  :label-cols="3" >
                    <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                    </v-date-picker>               
                  </b-form-group>
                </b-col>
                <b-col md="6" >
                  <b-button size="md" variant="primary" type="submit" @click="displaydata">Submit</b-button>
                </b-col>
              </b-row>             
            </b-form>
          </div>  
          <div class="table-responsive" id="searchlisting">
            <table class="table table-striped table-bordered" border="1" >
                <thead>
                    <tr v-if="data.length>0" >
                      <th>Delivery Agent Name</th>
                      <th>Total NDR</th>
                      <th>Total Delivered</th>
                      <th>Total Distance (Km)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="value in data">
                      <td> {{ value.daname }}</td>
                      <td> {{ value.totalndr }}</td>
                      <td> {{ value.totaldelivered }}</td>
                      <td> {{value.totaldistancekm }}</td>

                    </tr>
                </tbody>
            </table>
          </div>
        </b-card> 
      </b-col>
    </b-row>     
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'disbursmentReport',
      data: [],
      selectedDate:new Date(),
    }
  },
  computed:{},
  created: function () {
    this.displaydata()
  },
  methods: {
    validateForm(scope) {},
    refresh: function () {
      document.getElementById('refreshId').className = 'fa-spin fa fa-refresh'
      this.displaydata()
    },
    displaydata: function () {
      var fromdate = this.formatDate(this.selectedDate);
      // console.log("Date:"+fromdate);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //console.log(userInfo.pickuplocationpincode);
      const customerGetobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          fromdate: `${fromdate}`
      }
      //console.log(customerGetobj)
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/DisbursmentReport`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.data = result.body.returnvalue
    //        this.data.totaldistancekm=this.formatDistnace(this.data.totaldistancekm);
            document.getElementById('refreshId').className = 'fa fa-refresh'
          } else {
            alert('No records found');
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

  }
}
</script>
